/**
 * SentinelResponse
 * @author ftgibran
 */
import {$, ID, Model, HttpIgnore, ResponseFill} from 'simpli-web-sdk'

@HttpIgnore()
export default class SentinelResponse extends Model {
  readonly $name: string = 'SentinelResponse'

  @ResponseFill()
  idsCargaOccurrence: ID[] = []

  @ResponseFill()
  idsCargaReturned: ID[] = []

  @ResponseFill()
  idsAlertaCarga: ID[] = []

  @ResponseFill()
  idsMotoristaCancelamentoCarga: ID[] = []

  @ResponseFill()
  idsRelatorioGeracao: ID[] = []

  @ResponseFill()
  idsImportCargas: ID[] = []

  @ResponseFill()
  idsImportSLA: ID[] = []

  async getSentinelData(spinner = 'getSentinelData') {
    const fetch = async () => await this.GET(`/user/me/sentinela`, {
      headers: {
        'X-Ignore-Errors': '1',
      },
    })
    return await $.await.run(fetch, spinner)
  }
}
